import { Data } from 'signup-constants/signupData/Data';
import { getRecommendedHubletResponse } from '../store/http-responses/selectors';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { Step } from 'signup-constants/Step';
export const getPropertiesToTrack = state => {
  const hubletResponse = getRecommendedHubletResponse(state);
  const recommendedHublet = hubletResponse ? hubletResponse.region : null;
  const hublet = getSignupDataValue(state, Data.HubletSelection);
  const isUsingHubletRecommendation = hublet === recommendedHublet;
  return {
    [Step.HubletSelection]: {
      isUsingHubletRecommendation
    }
  };
};